import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";

const ThisOrThatCompletion = ({
  onPlayAgain,
  totalRounds,
  majorityPicks,
  brandColors = {
    primary: "#FF61D8",
    secondary: "#6366F1",
    background: "#F8F0FF",
    text: "#444",
    white: "#fff",
    black: "#000",
  },
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "1.1rem 0.5rem 1.5rem 0.5rem",
        maxWidth: "420px",
        width: "100%",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          mb: 1.2,
          fontWeight: 700,
          background: `linear-gradient(45deg, ${brandColors.primary} 30%, ${brandColors.secondary} 90%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        🎉 Game Complete!
      </Typography>

      <Box
        sx={{
          backgroundColor: "rgba(255,255,255,0.1)",
          borderRadius: "14px",
          p: 2.2,
          mb: 2.2,
          backdropFilter: "blur(8px)",
          border: "1px solid rgba(255,255,255,0.18)",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            mb: 0.5,
            fontWeight: 600,
            color: "text.primary",
          }}
        >
          You agreed with the crowd
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            background: `linear-gradient(45deg, ${brandColors.primary} 30%, ${brandColors.secondary} 90%)`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: "2.2rem",
          }}
        >
          {majorityPicks} of {totalRounds}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 0.2,
            color: "text.secondary",
          }}
        >
          times!
        </Typography>
      </Box>

      <Typography
        variant="body1"
        sx={{
          mb: 2.2,
          color: "text.secondary",
          maxWidth: "320px",
        }}
      >
        Thanks for playing! Want to try again with different choices?
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          onClick={onPlayAgain}
          sx={{
            background: `linear-gradient(45deg, ${brandColors.primary} 30%, ${brandColors.secondary} 90%)`,
            color: brandColors.white,
            px: 4,
            py: 1.1,
            borderRadius: "100px",
            fontSize: "1.1rem",
            fontWeight: 600,
            textTransform: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              background: `linear-gradient(45deg, ${brandColors.secondary} 30%, ${brandColors.primary} 90%)`,
              transform: "translateY(-2px)",
              boxShadow: `0 8px 16px ${brandColors.black}20`,
            },
          }}
        >
          Play Again
        </Button>

        <Button
          variant="outlined"
          onClick={() => {
            // In a real app, this would share to social media
            window.alert("Share functionality coming soon!");
          }}
          sx={{
            borderColor: brandColors.primary,
            color: brandColors.primary,
            px: 4,
            py: 1.1,
            borderRadius: "100px",
            fontSize: "1.1rem",
            fontWeight: 600,
            textTransform: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              borderColor: brandColors.secondary,
              color: brandColors.secondary,
              transform: "translateY(-2px)",
              boxShadow: `0 8px 16px ${brandColors.black}10`,
            },
          }}
        >
          Share Your Takes
        </Button>
      </Box>
    </motion.div>
  );
};

export default ThisOrThatCompletion;
